<template>
  <div id="calendar-filterform">
    <v-btn
      class="d-md-none"
      plain
      color="var(--theme-color-one)"
      @click="isShow=true">
      ตัวเลือกการแสดงผล
    </v-btn>
    <div :class="{'d-none': !isShow, 'd-md-block': true, 'form': true}">
      <v-container fluid>
        <v-row class="d-md-none">
          <v-col>
            <div class="font-18 my-5">
              ตัวเลือกการแสดงผล
              <v-icon class="float-right" @click="isShow=false">mdi-close</v-icon>
            </div>
          </v-col>
        </v-row>
        <TypesInput v-model="form.types" class="mb-2"/>
        <div class="date-wrapper mb-2">
          <YearInput v-model="form.year"/>
          <MonthInput v-model="form.month" v-if="showMonth"/>
          <DayInput
            v-if="showDay"
            v-model="form.day"
            :year="form.year"
            :month="form.month"
            :daterange="daterange"/>
        </div>
        <ItemIdsInput v-model="form.itemIds" class="mb-2"/>
        <v-row>
          <v-col class="text-right d-none d-sm-block">
            <v-btn
              color="var(--theme-color-two)"
              outlined
              class="mr-2"
              @click="reset">
              รีเซ็ต
            </v-btn>
            <v-btn
              color="var(--theme-color-one)"
              depressed
              dark
              @click="submit">
              ยืนยัน
            </v-btn>
          </v-col>
          <v-col class="d-sm-none">
            <v-btn
              color="var(--theme-color-two)"
              outlined
              block
              @click="reset">
              รีเซ็ต
            </v-btn>
          </v-col>
          <v-col class="d-sm-none">
            <v-btn
              color="var(--theme-color-one)"
              depressed
              dark
              block
              @click="submit">
              ยืนยัน
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'

import TypesInput from '@/components/calendar/FilterForm/Types.vue'
import DayInput from '@/components/calendar/FilterForm/Day.vue'
import MonthInput from '@/components/calendar/FilterForm/Month.vue'
import YearInput from '@/components/calendar/FilterForm/Year.vue'
import ItemIdsInput from '@/components/calendar/FilterForm/ItemIds.vue'

export default {
  components: {
    TypesInput,
    DayInput,
    MonthInput,
    YearInput,
    ItemIdsInput,
  },
  data() {
    return {
      isShow: false,
      form: {
        types: [],
        day: 1,
        month: 1,
        year: 2000,
        itemIds: [],
      },
    }
  },
  props: {
    daterange: { types: String, require: true },
  },
  mounted() {
    this.initFormData()
    this.$emit('filter', _.cloneDeep(this.form))
  },
  methods: {
    initFormData() {
      let today = moment()
      this.form = {
        types: this.typeKeys,
        day: today.date(),
        month: today.month(),
        year: today.year(),
        itemIds: [],
      }
    },
    submit() {
      this.$emit('filter', _.cloneDeep(this.form))
      this.isShow = false
    },
    reset() {
      this.initFormData()
      this.$emit('filter', _.cloneDeep(this.form))
    },
  },
  computed: {
    ...mapGetters({
      typeKeys: 'Calendar/getTypeKeys',
    }),
    showDay() {
      return ['day', 'week'].includes(this.daterange)
    },
    showMonth() {
      return ['day', 'week', 'month'].includes(this.daterange)
    },
  }
}
</script>

<style>
@media (min-width: 600px) {
  #calendar-filterform .date-wrapper .input{
    max-width: 200px;
  }
}
@media (max-width: 600px) {
  #calendar-filterform .form {
    position: fixed;
    top:0;
    left:0;
    right:0;
    background-color: white;
    z-index: 1000;
  }
}
</style>